import fetchRequest from "./fetchRequest";
import appSettings from "../settings/appSettings";
import { wvusLogger } from "../helpers";
import { TokenExIframeConfig } from "../types";
import { getPhrase } from "../languages";

const { iframeConfigSettings } = appSettings;

async function getTokenExIframeConfig(): Promise<TokenExIframeConfig> {
  const origins: string[] = [window.location.origin];
  const url: string = `${iframeConfigSettings.baseUrl}?noCache=${Date.now()}`;
  const requestOpts = {
    method: "POST",
    headers: {
      "x-authorization-key": `${iframeConfigSettings.authKey}`
    },
    body: JSON.stringify({
      data: {
        domains: origins
      }
    }),
    timeout: 15 * 1000
  };

  try {
    const resp = await fetchRequest(url, requestOpts);

    if (!resp.ok) {
      throw new Error(`Response ${resp.status} ${resp.statusText}`);
    }

    const jsonData = await resp.json();

    const iframeConfig: TokenExIframeConfig = jsonData?.data?.iframeConfig || {};
    if (
      !iframeConfig.authenticationKey &&
      !iframeConfig.tokenExID &&
      !iframeConfig.timestamp &&
      !iframeConfig.tokenScheme &&
      !iframeConfig.origin
    ) {
      throw new Error("Invalid iframe Config");
    }

    // TODO: Find A Way To Not Have To Override This Here
    iframeConfig.styles.base = appSettings.tokenExIframeStyles;
    iframeConfig.placeholder = `${getPhrase("payment_step.field_labels.card_number")} *`;
    // iframeConfig.debug = true;
    // iframeConfig.type = "tel";

    return iframeConfig;
  } catch (err) {
    wvusLogger.log(err, wvusLogger.getLogLevelNames().ERROR);
    return Promise.reject(err);
  }
}

export default getTokenExIframeConfig;
